define('realityCheck',['jquery', 'module', 'all/player/session', 'all/player/player', 'all/dialog', 'boxes/reality-check-popup/dialog'],
	/**
	 * @param $
	 * @param module
	 * @param slidingPanel
	 * @param session
	 * @param realityCheckPopupController
	 * @returns {{}}
	 */
	function ($, module, session, player, dialog, realityCheckDialog) {
		'use strict';
		var config = module.config(),
			api = {},
			properties,
			rcObject,
			flow = {
				'getTimeout': 'GetPlayerRealityCheck',
				'setTimeout': 'SetPlayerRealityCheck',
				'resetTimer': 'ResetPlayerRealityCheck',
				'getSessionData': 'PlayerRealityCheckPopupInfo'
			},

				SECOND_IN_MS = 1 * 1000,
				MINUTE_IN_MS = 60 * SECOND_IN_MS,
				POPUP_LEAD_S,
				POPUP_LEAD_MS,

		/* Keep well below the smallest possible user specified timeout value,
		 * which is 60 minutes.
		 */
			MAX_TIMEOUT = 30 * MINUTE_IN_MS,
			REALITY_CHECK_END_TIME_UTC_COOKIE = 'RCETU',
			REALITY_CHECK_CONTROL_COOKIE = 'RCCC',

			/**
			 * Descriptor for interface event handlers.
			 * @typedef {{selector: string, handler: function}} userInterfaceEventHandlerDescriptor
			 * @property {string} selector - argument for external:"Element".querySelectorAll
			 * @property {string} event - String representing the {external:"Event".type} to listen for
			 * @property {function} handler - Event handler
			 */
			popupUserInterfaceEventHandlerDescriptor;


		POPUP_LEAD_S = parseInt(config.POPUP_LEAD_TIME_SECONDS, 10);
		POPUP_LEAD_S = isNaN(POPUP_LEAD_S) ? 1 : POPUP_LEAD_S;
		POPUP_LEAD_MS = POPUP_LEAD_S * SECOND_IN_MS;

			/*
			 * Internal API - Pure functions only
			 */
			/**
			 * @pure
			 * Calculate number of milliseconds until the given timestamp value.
			 * This value will be modified if etcd properties REALITY_CHECK/POPUP_LEAD_TIME_SECONDS is set.
			 * @param {NaN|number} utc - UTC timestamp
			 * @param {number} delta - delta time between server and browser
			 * @returns {number} milliseconds until the next timeout function will run
			 */
			function timestampToTimeout(utc, delta) {
				if (isNaN(utc)) {
					return MAX_TIMEOUT;
				} else {
					return (utc - Date.now()) - POPUP_LEAD_MS - delta;
				}
			}

		/**
		 * @pure
		 * @returns {null|int} - Null or UTC timestamp
		 */
		function parseRealityCheckTimestampCookie() {
			var timestamp = parseInt($.cookie(REALITY_CHECK_END_TIME_UTC_COOKIE), 10);
			/**
			 * @pure
			 * @returns {NaN|int} - Null or UTC timestamp
			 */
			function parseRealityCheckTimestampCookie() {
				var timestamp = parseInt($.cookie(REALITY_CHECK_END_TIME_UTC_COOKIE), 10);

			// No reality check cookie
			if (isNaN(timestamp) || timestamp < 1) {
				return null;
			} else {
				return timestamp;
			}
		}
				// No reality check cookie
				if (isNaN(timestamp) || timestamp < 1) {
					return NaN;
				} else {
					return timestamp;
				}
			}

		/**
		 * Calculate difference between server system clock and client system clock
		 * @pure
		 * @param {object} - Cookies as name:value pairs
		 * @returns {number}
		 */
		function serverBrowserDeltaTime(controlCookie) {
			var timestamp = parseInt(controlCookie, 10),
				delta = this.serverBrowserDeltaTimeMs;

			if (!isNaN(timestamp)) {
				delta = timestamp - Date.now();
			}
			return delta;
		}

		/*
		 * Internal API - Always bind calling context to [this] when invoking these
		 */

		/**
		 * Clear timeout that checks for expired reality check.
		 * Bind calling context to [this] on invocation
		 */
		function timerOff() {
			window.clearTimeout(this.timeoutId);
			this.timeoutId = null;
		}

		/**
		 * IMPORTANT: This function has been disabled for iframed content.
		 * Set timeout to check for expired reality check.
		 * Bind calling context to [this] on invocation
		 * @param {number} timeout - Timeout in milliseconds
		 */
		function timerOn(timeout) {
			var self = this;

			if (window !== top) {
				return;
			}

			if (this.timeoutId) {
				timerOff.call(this);
			}

				if (timeout < SECOND_IN_MS) {
					if (session.authenticated) {
						realityPopup.call(this);
					}
				} else {
					timeout = Math.min(timeout, MAX_TIMEOUT);

					console.log('Check in: ' + timeout / 1000 + 's');
					this.timeoutId = window.setTimeout(function () {
						console.log('4. calling with delta: ' + self.serverBrowserDeltaTimeMs)
						timerOn.call(self, getTimeoutValue.call(self, self.serverBrowserDeltaTimeMs));
					}, timeout);
				}
			}

		/**
		 * Send new value to server. Then reset timer.
		 * @param {number} minutes
		 */
		function setRealityCheckDuration(minutes) {
			var deferred = $.Deferred();

				dialog.flow(flow.setTimeout, { 'duration': minutes }, (function (self, duration) {
					return function () {
						self.serverBrowserDeltaTimeMs = serverBrowserDeltaTime.call(self, $.cookie(REALITY_CHECK_CONTROL_COOKIE));
						timerOn.call(self, getTimeoutValue.call(self, self.serverBrowserDeltaTimeMs));
						deferred.resolve(duration);
					};
				}(this, minutes)));

			return deferred.promise();
		}

			function getTimeoutValue(deltaTime) {
				var timestamp = parseRealityCheckTimestampCookie(),
					msUntilTimestamp = timestampToTimeout(timestamp, deltaTime);

				return msUntilTimestamp;
			}

		/*
		 * Public API - method definitions.
		 * Always bind [this] when calling internal API.
		 */

		/**
		 * Show sliding-content popup.
		 */
		function realityPopup() {
			this.dialogController.showDialog();
		}

		/**
		 * Reset timer server side, then start new window.timeout.
		 * [this] bound to reality check object
		 * @returns {*}
		 */
		function resetRealityCheckTimer() {
			this.dialogController.closeDialog();

				dialog.flow(flow.resetTimer, {}, (function (self) {
					return function () {
						self.serverBrowserDeltaTimeMs = serverBrowserDeltaTime.call(self, $.cookie(REALITY_CHECK_CONTROL_COOKIE));
						console.log('1. calling with delta: ' + self.serverBrowserDeltaTimeMs)
						timerOn.call(self, getTimeoutValue.call(self, self.serverBrowserDeltaTimeMs));
					};
				}(this)));
			}

			function startRealityCheck() {
				console.log('2. calling with delta: ' + this.serverBrowserDeltaTimeMs)
				timerOn.call(this, getTimeoutValue.call(this, this.serverBrowserDeltaTimeMs));
			}

		/**
		 * [this] bound to reality check object
		 */
		function logout() {
			this.dialogController.closeDialog();
			player.logout();
		}

			function setConfigElementToRealityCheckDisabled() {
				if (this.configElement) {
					this.configElement.selectedIndex = this.configElement.options.length - 1;
				}
			}

		function assignRealityConfigElement(select) {
			var self = this;
			this.configElement = select;
			if (select) {
				select.addEventListener('change', function (e) {
					setRealityCheckDuration.call(self, e.target.value);
				});
			}
		}

		// public API
		api.realityPopup = realityPopup;
		api.resetRealityCheckTimer = resetRealityCheckTimer;
		api.setRealityCheckDuration = setRealityCheckDuration;
		api.startRealityCheck = startRealityCheck;
		api.assignRealityConfigElement = assignRealityConfigElement;

		// object ownProperties
		properties = {
			configElement: {
				writable: true,
				enumerable: true,
				configurable: false,
				value: null
			},
			dialogController: {
				writable: true,
				enumerable: true,
				configurable: false,
				value: null
			},
			serverBrowserDeltaTimeMs: {
				writable: true,
				enumerable: true,
				configurable: false,
				value: 0
			},
			timeoutId: {
				writable: true,
				enumerable: true,
				configurable: false,
				value: null
			}
		};

		rcObject = Object.create(api, properties);

		/**
		 * [this] bound to reality check object
		 */
		function disableRealityCheck() {
			var self = this;
			this.dialogController.closeDialog();

				setRealityCheckDuration.call(this, '-1')
					.then(
						function (duration) {
							setConfigElementToRealityCheckDisabled.call(self, duration);
						},
						undefined
					);
			}

		function disableHandler() {
			disableRealityCheck.call(rcObject);
		}

		function resetHandler() {
			resetRealityCheckTimer.call(rcObject);
		}

		function logoutHandler() {
			logout.call(rcObject);
		}

		function accHistHandler(event) {
			event.preventDefault();
			resetHandler();
			window.location = event.target.href;
		}

		popupUserInterfaceEventHandlerDescriptor = [{
			selector: '#reality-check-popup-disable',
			event: 'click',
			/* Cannot be included among define([dependencies]) */
			handler: disableHandler
		}, {
			selector: '#reality-check-popup-reset',
			event: 'click',
			/* Cannot be included among define([dependencies]) */
			handler: resetHandler
		}, {
			selector: '#reality-check-popup-logout',
			event: 'click',
			handler: logoutHandler
		}, {
			selector: '#reality-check-popup-acc-hist-link',
			event: 'click',
			handler: accHistHandler
		}];

			rcObject.dialogController = realityCheckDialog.create(popupUserInterfaceEventHandlerDescriptor);
			// There can be no reality check unless user has logged in
			if (session.authenticated) {
				console.log('3. calling with delta: ' + rcObject.serverBrowserDeltaTimeMs)
				timerOn.call(rcObject, getTimeoutValue.call(rcObject, rcObject.serverBrowserDeltaTimeMs));
			}

		return /** @exports realityCheck */ rcObject;
});

